<template>
  <parts @remove="$emit('remove')" title="背景">
    <td>
      <b-form-input v-model="form.src" debounce="500" />
      <b-img width="250px" height="150px" :src="form.src" fluid />
      <b-form-checkbox
        v-model="form.anime"
        value="1"
        unchecked-value="0"
      >
        フェードイン
      </b-form-checkbox>        
    </td>
  </parts>
</template>

<script>
import parts from './parts'
export default {
  name: 'set-bg',
  props:{
    options: Object,
    iconList: Array
  },
  components:{
    parts
  },
  data () {
    return {
      form: {
        src: this.options.src,
        anime: this.options.anime
      },
    }
  },
  watch: {
    'form.src': function(){
      this.$emit('input', this.form)
    },
    'form.anime': function(){
      this.$emit('input', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
